

































































import { Vue, Component } from 'vue-property-decorator';
import CollapseTransition from '@/components/collapseTransition/collapseTransition.ts';
import ProcessEdit from '@/views/yunnan-work/workingBill/workingBillManagement/unit/processManagement/processEdit/processEdit.vue';
import { dictServe, siteManagementServer } from '@/api/installServer';
import { TableStripe } from '@/mixins/tableStripe';

@Component({
  components: { CollapseTransition, ProcessEdit },
  mixins: [TableStripe],
})
export default class User extends Vue {
  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };

  private loading: any = false; // 表格加载
  private formShow = false; // 是否显示搜索表单内容
  private total = 0; // 数据总共多少条
  private editRoleFlag: any = 1; // 控制显示 编辑 页面
  private showFlag = 'list'; // 显示标记 list 列表 edit 编辑

  // 表单数据对象
  formData: any = {
    name: '', // 名称
  };

  // 表单数据对象
  form: any = {
    id: '',
    name: '', // 字典名称
    description: '', // 字典描述
  };

  // table 数据对象
  tableData: any = [];

  /**
   * @todo 后期需要优化的部分
   * @desc 点击隐藏或查询按钮触发，隐藏或显示搜索表单内容。
   * @param1 暂无
   * @returns 暂无
   */

  private created() {
    this.getData();
  }

  editFunction(row: any) {
    // console.log(row);
    this.showFlag = 'edit';
    this.$nextTick(() => {
      const refName = 'processEdit';
      const ref: any = this.$refs['processEdit'];
      // console.log(ref);
      ref.showEdit(row);
    });
  }

  backFunction() {
    this.showFlag = 'list';
  }

  private getData() {
    siteManagementServer
      .getWorkTicketConfigAll({})
      .then((res: any) => {
        this.tableData = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    this.queryDataForm.pageNo = 1;
    this.getData();
  }

  /**
   * @desc 点击重置按钮触发，重置搜索表单内容.
   * @param1 暂无
   * @returns 暂无
   */
  resetForm() {
    this.formData.name = '';
    this.queryDataForm.pageNo = 1;
    this.queryDataForm.pageSize = 10;
    this.getData();
  }
}
